import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from 'reactstrap';
import { faAngleDown, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAuth } from '../../../orbit/auth/AuthProvider';
import { useMe } from '../../../orbit/me/MeProvider';
import { BrandSwitcher } from '../../../orbit/brand/BrandSwitcher';
import { FixtureModeBadge } from '../../../orbit/components/FixtureModeBadge';
import { TicketsBell } from '../../../orbit/pages/Tickets';

/**
 * Orbit UserBox — minimal:
 *  - Brand-Switcher (Dropdown)
 *  - User-Pill mit Display-Name + Core-Rolle
 *  - Profile/Logout
 *
 * Ersetzt das ArchitectUI-Demo (Messages / Timeline / System).
 */
export default function UserBox() {
  const auth = useAuth();
  const { me } = useMe();
  const navigate = useNavigate();

  const onLogout = () => {
    auth.signOut();
    navigate('/login', { replace: true });
  };

  return (
    <Fragment>
      <div className="header-btn-lg pe-0">
        <div className="widget-content p-0">
          <div className="widget-content-wrapper d-flex align-items-center gap-3">
            <FixtureModeBadge />
            <TicketsBell />
            <BrandSwitcher />

            <UncontrolledButtonDropdown>
              <DropdownToggle color="link" className="p-0 d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faUserCircle}
                  className="text-secondary"
                  style={{ fontSize: 28 }}
                />
                <FontAwesomeIcon className="ms-2 opacity-8" icon={faAngleDown} />
              </DropdownToggle>
              <DropdownMenu end className="rm-pointers">
                <div className="px-3 py-2">
                  <div className="fw-semibold">{me?.user?.displayName ?? '—'}</div>
                  <div className="text-muted small">
                    {me?.user?.email}
                    {me?.user?.role && (
                      <>
                        {' · '}
                        <span className="text-uppercase">{me.user.role}</span>
                      </>
                    )}
                  </div>
                </div>
                <DropdownItem divider />
                <DropdownItem onClick={() => navigate('/me')}>Mein Profil</DropdownItem>
                <DropdownItem onClick={() => navigate('/me/security')}>Sicherheit &amp; MFA</DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={onLogout}>Abmelden</DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
